import React from 'react'

export const ZebraIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="85"
    height="85"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.9634 0H7.32026C3.27739 0 0 3.27739 0 7.32026V26.9634C0 31.0063 3.27739 34.2837 7.32026 34.2837H26.9634C31.0063 34.2837 34.2837 31.0063 34.2837 26.9634V7.32026C34.2837 3.27739 31.0063 0 26.9634 0Z"
      fill="#282624"
    />
    <path
      d="M22.714 5.41949C21.3189 4.17173 19.8614 3.62365 18.3491 3.7908C17.6543 3.87226 16.9825 4.08886 16.3718 4.42828L19.3221 9.53204C19.4327 9.6606 19.5187 9.80813 19.5761 9.9674L22.2177 14.5153L22.5498 14.146C24.0074 12.5407 24.7421 10.9897 24.7577 9.50484C24.7733 8.01996 24.0934 6.65559 22.714 5.41949ZM11.7412 19.8406L11.0183 20.6181C9.74438 22.0252 9.13087 23.4362 9.19339 24.8395C9.25592 26.2427 9.97493 27.5604 11.3739 28.8276C12.7728 30.0948 14.2421 30.7245 15.7075 30.6662C16.4097 30.6406 17.0978 30.4628 17.7239 30.1453L11.7412 19.8406ZM18.564 12.2919L13.1831 18.2392L15.4144 22.0524L20.7797 16.1012L18.564 12.2919ZM22.542 19.1448L17.3136 24.9988L17.1768 25.131L19.3846 28.9365C19.5253 28.8004 19.666 28.6566 19.8066 28.5011L24.7538 22.9503L22.542 19.1448ZM14.7032 5.63328C14.4294 5.87879 14.1685 6.13828 13.9217 6.4107L9.31844 11.5805L11.5341 15.4016L16.8837 9.41154L14.7032 5.63328ZM3.76172 17.7999L6.13759 21.4421L10.1039 17.0069L7.88432 13.182L3.76172 17.7999ZM27.9893 13.0149L23.9722 17.5356L26.184 21.3527L30.3808 16.6532L27.9893 13.0149Z"
      fill="white"
    />
  </svg>
)
